var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsUUID } from 'class-validator';
/**
 * Body for `POST /appointments/:id/confirm-booking` (PRD #1343, RS-007). Confirm
 * is one-click by default (empty body). When the patient chose "egal", the
 * practice may reassign the hold to a specific therapist at confirm by supplying
 * `assignTherapistId` — the doctorId is updated and the hold confirmed in the
 * same transaction. The practice, seeing its own calendar, is the authority on
 * who is free (broader conflict validation is deferred, per the Heilmittel-
 * katalog epic).
 */
export class ConfirmBookingDto {
    assignTherapistId;
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], ConfirmBookingDto.prototype, "assignTherapistId", void 0);
//# sourceMappingURL=confirm-booking.dto.js.map